import { PropsWithChildren, useLayoutEffect, useRef } from "react";
import { AxiosError, AxiosResponse, HttpStatusCode } from "axios";
import { useIntercom } from "react-use-intercom";
import { useAuth } from "@/features/auth";
import client from "./axios";

const AxiosInterceptor = ({ children }: Required<PropsWithChildren>): JSX.Element => {
  const { logout, reloadUser } = useAuth();
  const firstUpdate = useRef(true);
  const { shutdown, boot } = useIntercom();

  useLayoutEffect(() => {
    if (firstUpdate.current) {
      const successResponseInterceptor = (response: AxiosResponse) => {
        /*
        We don't want to do this for subscription because of the 3d secure
        edge case and the race condition when starting subscription.
        Reloading the user after the subscription is started will be done in
        the subscription feature
        */

        if (response.config.url !== "/subscriptions") reloadUser();
        return response;
      };
      const errInterceptor = <T extends AxiosError>(error: T) => {
        const { response, request } = error;
        if (!request.responseURL.includes("login_check") && response?.status === HttpStatusCode.Unauthorized) {
          logout({ unauthorized: true });
          shutdown();
          boot();
        }
        return Promise.reject(error);
      };

      client.interceptors.response.use(successResponseInterceptor, errInterceptor);
      firstUpdate.current = false;
    }
  });

  return children as JSX.Element;
};

export default AxiosInterceptor;
